import { useSelector } from "react-redux";
import { RootState } from "../store";

/**
 * Custom hook to get the selected location.
 * Prioritizes UI-selected location over app-selected location.
 * 
 * @returns The selected location from Redux state
 * 
 * @example
 * ```tsx
 * const selectedLocation = useSelectedLocation();
 * ```
 */
export const useSelectedLocation = () => {
  // Prefer UI-selected location; fall back to appData-selected location
  const uiSelectedLocation = useSelector(
    (state: RootState) => state.uiPreferences.selectedLocation
  );
  const appSelectedLocation = useSelector(
    (state: RootState) => state.appData.selectedLocation
  );
  
  return uiSelectedLocation ?? appSelectedLocation;
};
